import React from "react";
import CustomTable from "../../../../../components/table/CustomTable";
import SearchSimple from "../../../../../components/SearchSimples/SearchSimple";
import {RequestAccessHistoryTableApp} from "../Functionality/RequestAccessHistoryTableApp";
import RequestAccessModal from "../Modal/RequestAccessModal";

/**
 * @email kpozos@ibl.mx
 * @author Karen Yunuen Pozos Arias
 * @title Full Stack Developer
 */

const RequestAccessHistoryTable = (props) => {
    const {item} = props;
    const {
        t,
        tableId,
        searchId,
        option,
        thead,
        tbody,
        detailsModal,
        setDetailsModal,
        itemSelected,
        setItemSelected,
        setBodyForExport,
        searchElement,
        setSearchElement,
        setResults,
        page,
        rowsPerPage,
        setSimpleSearch,
        search,
        setSearch,
        pagination,
        getActionsButtons,
    } = RequestAccessHistoryTableApp({
        item
    });

    return (
        <>
            <SearchSimple
                id={searchId}
                setBodyForExport={setBodyForExport}
                setSearchResults={setResults}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                optionTable={option}
                rowsPerPage={rowsPerPage}
                setSimpleSearch={setSimpleSearch}
                search={search}
                setSearch={setSearch}
                contractorId={item.id}
                supplierId={null}
            />
            <CustomTable
                tableId={tableId}
                checkbox={false}
                thead={thead}
                tbody={tbody}
                columnActions={true}
                getActionsButtons={getActionsButtons}
                textNotInformation={tbody?.data?.length === 0 ? "no_requests_found" : null}
            />
            {pagination()}

            { (itemSelected && detailsModal) &&
                <RequestAccessModal
                    show={detailsModal}
                    onHide={() => {
                        setDetailsModal(false);
                        setItemSelected(null);
                    }}
                    itemSelected={itemSelected}
                />
            }
        </>
    );
};

export default RequestAccessHistoryTable;
